import * as React from "react";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { TransferDestinationAccountsClient } from "../../../../../../../Wrap/Api/Transfer/TransferAccounts/TransferDestinationAccounts";
import { TransferInRequestClient } from "../../../../../../../Wrap/Api/Transfer/TransferInRequest";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { TransferDestinationAccountModel } from "../../../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { TransferDestinationAccountPaginatedModel } from "../../../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountPaginatedModel";
import { TransferISTSelection } from "../../../../../../../Wrap/Models/Models/InstrumentSelection/TransferISTSelection";
import { Investment } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";

export class AccountSearchPopup extends FormComponent<
    {
        onChange: (v: TransferDestinationAccountModel, cgtExempt: boolean, changeOfbeneficial: boolean) => void;
        onInvestmentsChange: (v: TransferISTSelection[]) => void;
        onLoadingInvestments: (v: boolean) => void;
        serviceProposition: ServiceProposition;
        claccountId: string;
        subAccountType?: SubAccountType;
        showcgtExempt?: boolean;
    },
    {
        searchInput: string;
        accountSelected: TransferDestinationAccountModel;
        accountList: Array<TransferDestinationAccountModel>;
        warningMsg: string;
        changeOfbeneficial: boolean;
        cgtExempt: boolean;
    }
> {
    constructor(props) {
        super(props);
        this.state = {
            searchInput: null,
            accountSelected: null,
            accountList: [],
            warningMsg: null,
            changeOfbeneficial: null,
            cgtExempt: false,
        };
    }

    public render(): JSX.Element {
        const { warningMsg, accountSelected, changeOfbeneficial, accountList } = this.state;
        return (
            <>
                <div>
                    {warningMsg && <Alert alertType={AlertType.Warning} message={this.state.warningMsg} />}
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            cssWrapper="control-size-430"
                            value={this.state.searchInput}
                            label={"Account number"}
                            onChange={(v) => {
                                this.setState({ searchInput: v });
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <button className="btn secondary label-offset" onClick={() => this.onSearch()}>
                            Search
                        </button>
                    </div>
                    {accountList && accountList.length > 0 && (
                        <>
                            <div>
                                <SelectEditor
                                    cssWrapper="control-size-430"
                                    options={accountList.map((x) => {
                                        return x.ClAccountId;
                                    })}
                                    getText={(v) => {
                                        return accountSelected.ProductDisplayName;
                                    }}
                                    onChange={(v) => {
                                        const account = accountList.find((x) => x.ClAccountId == v);
                                        this.setState({
                                            accountSelected: account,
                                        });
                                    }}
                                    selected={accountList[0].ClAccountId}
                                    label="Account type"
                                ></SelectEditor>
                            </div>
                            {!this.IsSameHeaderTransfer() && (
                                <>
                                    {this.props.showcgtExempt && (
                                        <div>
                                            <CheckboxEditor
                                                value={this.state.cgtExempt}
                                                label="CGT exempt"
                                                cssWrapper="square-checkbox block"
                                                onChange={(v) => {
                                                    this.setState({ cgtExempt: v });
                                                }}
                                            ></CheckboxEditor>
                                        </div>
                                    )}
                                    <div>
                                        <RadiosEditor
                                            cssWrapper="rg-inline mb-16"
                                            label={"Does this transfer involve a change of beneficial owner?"}
                                            getText={(v) => {
                                                return v == null ? "" : v ? "Yes" : "No";
                                            }}
                                            selected={changeOfbeneficial}
                                            options={[true, false]}
                                            onChange={(v) => {
                                                this.setState({ changeOfbeneficial: v });
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            <div>
                                <button
                                    className="btn secondary label-offset"
                                    onClick={() => {
                                        if (accountSelected != null && this.isValid()) {
                                            this.onGetInvestments();
                                        }
                                    }}
                                >
                                    Go
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </>
        );
    }

    private IsSameHeaderTransfer(): boolean {
        const clAccountId = getQueryParameters()["claccountid"]
            ? getQueryParameters()["claccountid"]
            : this.props.claccountId;
        if (CommonHelper.isNullOrEmpty(clAccountId)) {
            return false;
        }
        const { accountSelected } = this.state;
        if (clAccountId.split("-")[0] == accountSelected.ClAccountId.split("-")[0]) {
            return true;
        }
        return false;
    }

    private IsSameHeaderForSearch(): boolean {
        const clAccountId = getQueryParameters()["claccountid"];
        const { searchInput } = this.state;
        if (CommonHelper.isNullOrEmpty(clAccountId) || CommonHelper.isNullOrEmpty(searchInput)) {
            return false;
        }
        if (clAccountId.includes(searchInput.toUpperCase())) {
            return true;
        }
        return false;
    }

    private onSearch() {
        if (this.state.searchInput == null) {
            this.setState({ warningMsg: "You must enter search criteria." });
        } else {
            const { searchInput } = this.state;
            const claccountid = getQueryParameters()["claccountid"];
            const client = new TransferDestinationAccountsClient();
            const promise = client.get(
                null,
                searchInput,
                null,
                null,
                5,
                1,
                this.props.subAccountType,
                null,
                ServiceProposition.NotSpecified
            );
            promise.onSuccess((result: TransferDestinationAccountPaginatedModel) => {
                if (result) {
                    let subAccounts = result.SubAccounts;
                    if (this.IsSameHeaderForSearch()) {
                        subAccounts = subAccounts.filter((f) => f.ClAccountId != claccountid);
                    }
                    this.setState({
                        accountList: subAccounts,
                        accountSelected: subAccounts[0],
                        warningMsg: null,
                    });
                } else {
                    this.setState({ warningMsg: "Unable to transfer from client account." });
                }
            });
        }
    }

    private onGetInvestments() {
        const { accountSelected, cgtExempt, changeOfbeneficial } = this.state;
        if (accountSelected != null) {
            const client = new TransferInRequestClient();
            const promise = client.get(accountSelected.ClAccountId, cgtExempt);
            promise.onSuccess((result) => {
                if (result.length == 1 && result[0].InstrumentCode == "0") {
                    this.setState({ warningMsg: result[0].DisplayName });
                } else {
                    this.props.onLoadingInvestments(true);
                    this.props.onChange(accountSelected, cgtExempt, changeOfbeneficial);
                    const investments: TransferISTSelection[] = [];
                    result.forEach(function (v) {
                        const investment: Investment = {
                            InstrumentCode: v.InstrumentCode,
                            ProductId: v.ProductId,
                            DisplayName: v.DisplayName,
                            UnitPrice: v.UnitPrice,
                            MarketValue: v.MarketValue,
                            TaxBookCost: v.TaxBookCost,
                            AcquisitionDate: v.AcquisitionDate,
                        };
                        investments.push({
                            Investment: investment,
                            Units: v.Quantity,
                            QuotationValue: {
                                Amount: v.Quantity * v.UnitPrice.Amount,
                                Currency: CurrencyCode.GBP,
                            },
                        });
                    });
                    this.props.onInvestmentsChange(investments);
                    this.props.onLoadingInvestments(false);
                }
            });
        }
    }
}
